import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DocPropertiesState {
  properties: Record<string, string> | null;
  isLoading: boolean;
}

const initialState: DocPropertiesState = {
  properties: null,
  isLoading: false,
};

const docPropertiesSlice = createSlice({
  name: "docProperties",
  initialState,
  reducers: {
    setProperties(state, action: PayloadAction<Record<string, string>>) {
      state.properties = action.payload;
      state.isLoading = false;
    },
    updateProperty(state, action: PayloadAction<{ key: string; value: string }>) {
      if (state.properties) {
        state.properties[action.payload.key] = action.payload.value;
      } else {
        state.properties = { [action.payload.key]: action.payload.value };
      }
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export const { setProperties, updateProperty, setIsLoading } = docPropertiesSlice.actions;

export const selectDocProperties = (state: { docProperties: DocPropertiesState }) => state.docProperties.properties;
export const selectDocPropertiesIsLoading = (state: { docProperties: DocPropertiesState }) =>
  state.docProperties.isLoading;

export default docPropertiesSlice.reducer;
